import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'clientes',
  getAllParams: ({
    include, nif, page, perPage, search, to,
  }) => ({
    'filter[nombre]': search,
    'filter[nif]': nif,
    include,
    page,
    per_page: perPage,
    to,
  }),

});
